import(/* webpackMode: "eager" */ "/tmp/8de64f006350cf0/app/[locale]/error.tsx");
